<template>
  <div class="wrapper">
    <AppContent />
    <AppAudio v-for="sound in sounds" :key="sound.id" :id="sound.id" />
    <AppSoundSwitcher v-if="currentStep.id < 2" />
    <img class="answer-image" src="@/assets/images/answer-bg.jpg" alt="image description" aria-hidden="true">
    <img class="answer-image" src="@/assets/images/c2-bg.jpg" alt="image description" aria-hidden="true">
    <img class="answer-image" src="@/assets/images/c3-bg.jpg" alt="image description" aria-hidden="true">
    <img class="answer-image" src="@/assets/images/c4-bg.jpg" alt="image description" aria-hidden="true">
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import AppContent from '@/components/Content'
  import AppAudio from '@/components/Audio'
  import AppSoundSwitcher from '@/components/elements/SoundSwitcher'

  export default {
    name: 'App',
    components: {
      AppContent,
      AppAudio,
      AppSoundSwitcher
    },
    computed: {
      ...mapGetters({
        sounds: 'getSounds',
        currentStep: 'getCurrentStep'
      })
    },
    mounted() {
      function vh() {
        document.documentElement.style.setProperty('--full-viewport', `${window.innerHeight}px`);
      }
      vh();
      window.addEventListener('resize', vh);
      window.addEventListener('orientationchange', vh);
    },
    unmounted() {
      window.removeEventListener("resize", this.getTableHeight);
    },
  }
</script>
